import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=22e06471"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports